import React, { useState, useEffect } from 'react';
import { Html } from '@react-three/drei';
import * as THREE from 'three';

const DisplayClickableItem: React.FC<{
  position: [number, number, number];
  width: number;
  height: number;
  depth: number;
  message: string;
  visible?: boolean;
}> = ({ position, width, height, depth, message, visible = true }) => {
  const [color, setColor] = useState<THREE.Color | string>(
    new THREE.Color('grey')
  );
  const [opacity, setOpacity] = useState<number>(0.5);
  const [clicked, setClicked] = useState<boolean>(false);
  const [showText, setShowText] = useState<boolean>(false);

  const handleClick = () => {
    setClicked(!clicked);
    setShowText(true);
  };

  useEffect(() => {
    if (clicked) {
      const timer = setTimeout(() => setShowText(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [clicked]);

  useEffect(() => {
    if (!visible) {
      setOpacity(0);
    } else {
      setOpacity(0.4);
      setColor(new THREE.Color('grey'));
    }
  }, [visible]);

  return (
    <>
      <mesh position={position} onClick={handleClick}>
        <boxGeometry args={[width, height, depth]} />
        <meshStandardMaterial
          color={color}
          transparent
          opacity={opacity}
          side={THREE.DoubleSide}
        />
      </mesh>

      {clicked && showText && (
        <Html
          position={[position[0], position[1] + height / 2 + 0.5, position[2]]}
          center
        >
          <div className="bg-black text-white p-2 rounded text-sm">
            {message}
          </div>
        </Html>
      )}
    </>
  );
};

export default DisplayClickableItem;
